import { RowProps }  from 'components/Form/Row';

export interface ServerLocation {
  ip: string,
  isp: string,
  as: string,
  city: string,
  region: string,
  regionName: string,
  country: string,
  countryCode: string,
  zip: string,
  lat: number,
  lon: number,
  timezone: string,
  org: string,
  in_eu: boolean,
  currency: string,
};

export const getUserLocation = (response: any): UserLocation => {
  return {
    ip: response.query,
    isp: response.isp,
    as: response.as,
    city: response.city,
    region: response.region,
    regionName: response.regionName,
    country: response.country,
    countryCode: response.countryCode,
    zip: response.zip,
    lat: response.lat,
    lon: response.lon,
    timezone: response.timezone,
    org: response.org,
    in_eu: response.in_eu,
    currency: response.currency,
  };
};

export interface UserLocation {
  ip: string,
  isp: string,
  as: string,
  city: string,
  region: string,
  regionName: string,
  country: string,
  countryCode: string,
  zip: string,
  lat: number,
  lon: number,
  timezone: string,
  org: string,
  in_eu: boolean,
  currency: string,
};

export const getLocation = (response: any): ServerLocation => {
  return {
    ip: response.query,
    isp: response.isp,
    as: response.as,
    city: response.city,
    region: response.region,
    regionName: response.regionName,
    country: response.country,
    countryCode: response.countryCode,
    zip: response.zip,
    lat: response.lat,
    lon: response.lon,
    timezone: response.timezone,
    org: response.org,
    in_eu: response.in_eu,
    currency: response.currency,
  };
};

// export interface ServerLocation {
//   ip: string,
//   network: string,
//   version: string,
//   city: string,
//   region: string,
//   region_code: string,
//   country: string,
//   country_name: string,
//   country_code: string,
//   country_code_iso3: string,
//   country_capital: string,
//   country_tld: string,
//   continent_code: string,
//   in_eu: boolean,
//   postal: string,
//   latitude: number,
//   longitude: number,
//   timezone: string,
//   utc_offset: string,
//   country_calling_code: string,
//   currency: string,
//   currency_name: string,
//   languages: string,
//   country_area: string,
//   country_population: string,
//   asn: string,
//   org: string,

// };

// export const getUserLocation = (response: any): UserLocation => {
//   return {
//     ip: response.ip,
//     network: response.network,
//     version: response.version,
//     city: response.city,
//     region: response.region,
//     region_code: response.region_code,
//     country: response.country,
//     country_name: response.country_name,
//     country_code: response.country_code,
//     country_code_iso3: response.country_code_iso3,
//     country_capital: response.country_capital,
//     country_tld: response.country_tld,
//     continent_code: response.continent_code,
//     in_eu: response.in_eu,
//     postal: response.postal,
//     latitude: response.latitude,
//     longitude: response.longitude,
//     timezone: response.timezone,
//     utc_offset: response.utc_offset,
//     country_calling_code: response.country_calling_code,
//     currency: response.currency,
//     currency_name: response.currency_name,
//     languages: response.languages,
//     country_area: response.country_area,
//     country_population: response.country_population,
//     asn: response.asn,
//     org: response.org,
//   };
// };


// export interface UserLocation {
//   ip: string,
//   network: string,
//   version: string,
//   city: string,
//   region: string,
//   region_code: string,
//   country: string,
//   country_name: string,
//   country_code: string,
//   country_code_iso3: string,
//   country_capital: string,
//   country_tld: string,
//   continent_code: string,
//   in_eu: boolean,
//   postal: string,
//   latitude: number,
//   longitude: number,
//   timezone: string,
//   utc_offset: string,
//   country_calling_code: string,
//   currency: string,
//   currency_name: string,
//   languages: string,
//   country_area: string,
//   country_population: string,
//   asn: string,
//   org: string,
// };

// export const getLocation = (response: any): ServerLocation => {
//   return {
//     ip: response.ip,
//     network: response.network,
//     version: response.version,
//     city: response.city,
//     region: response.region,
//     region_code: response.region_code,
//     country: response.country,
//     country_name: response.country_name,
//     country_code: response.country_code,
//     country_code_iso3: response.country_code_iso3,
//     country_capital: response.country_capital,
//     country_tld: response.country_tld,
//     continent_code: response.continent_code,
//     in_eu: response.in_eu,
//     postal: response.postal,
//     latitude: response.latitude,
//     longitude: response.longitude,
//     timezone: response.timezone,
//     utc_offset: response.utc_offset,
//     country_calling_code: response.country_calling_code,
//     currency: response.currency,
//     currency_name: response.currency_name,
//     languages: response.languages,
//     country_area: response.country_area,
//     country_population: response.country_population,
//     asn: response.asn,
//     org: response.org,
//   };
// };

// export const getLocation = (response: any): ServerLocation => {
//   return {
//     ip: response.ip,
//     network: response.network,
//     version: response.version,
//     city: response.city,
//     region: response.region,
//     region_code: response.region_code,
//     country: response.country,
//     country_name: response.country_name,
//     country_code: response.country_code,
//     country_code_iso3: response.country_code_iso3,
//     country_capital: response.country_capital,
//     country_tld: response.country_tld,
//     continent_code: response.continent_code,
//     in_eu: response.in_eu,
//     postal: response.postal,
//     latitude: response.latitude,
//     longitude: response.longitude,
//     timezone: response.timezone,
//     utc_offset: response.utc_offset,
//     country_calling_code: response.country_calling_code,
//     currency: response.currency,
//     currency_name: response.currency_name,
//     languages: response.languages,
//     country_area: response.country_area,
//     country_population: response.country_population,
//     asn: response.asn,
//     org: response.org,
//   };
// };

export interface Whois {
  created: string,
  expires: string,
  updated: string,
  nameservers: string[],
}
export interface ServerInfo {
  org: string,
  asn: string,
  isp: string,
  os?: string,
  ip?: string,
  ports?: string,
  loc?: string,
  type?: string,
};

export const getServerInfo = (response: any): ServerInfo => {
  return {
    org: response.org,
    asn: response.asn,
    isp: response.isp,
    os: response.os,
    ip: response.ip_str,
    ports: response?.ports?.toString(),
    loc: response.city ? `${response.city}, ${response.country_name}` : '',
    type: response.tags ? response.tags.toString() : '',
  };
};

export interface HostNames {
  domains: string[],
  hostnames: string[],
};

export const getHostNames = (response: any): HostNames | null => {
  const { hostnames, domains } = response;
  if ((!domains || domains.length < 1) && (!hostnames || hostnames.length < 1)) {
    return null;
  }
  const results: HostNames = {
    domains: domains || [],
    hostnames: hostnames || [],
  };
  return results;
};

export interface ShodanResults {
  hostnames: HostNames | null,
  serverInfo: ServerInfo,
}

export const parseShodanResults = (response: any): ShodanResults => {
  return {
    hostnames: getHostNames(response),
    serverInfo: getServerInfo(response),
  };
}

export interface Technology {
  Categories?: string[];
  Parent?: string;
  Name: string;
  Description: string;
  Link: string;
  Tag: string;
  FirstDetected: number;
  LastDetected: number;
  IsPremium: string;
}

export interface TechnologyGroup {
  tag: string;
  technologies: Technology[];
}

export const makeTechnologies = (response: any): TechnologyGroup[] => {
  let flatArray = response.Results[0].Result.Paths
    .reduce((accumulator: any, obj: any) => accumulator.concat(obj.Technologies), []);
  let technologies = flatArray.reduce((groups: any, item: any) => {
    let tag = item.Tag;
    if (!groups[tag]) groups[tag] = [];
    groups[tag].push(item);
    return groups;
  }, {});
  return technologies;
};

export type Cookie = {
  name: string;
  value: string;
  attributes: Record<string, string>;
};

export const parseRobotsTxt = (content: string): { robots: RowProps[] } => {
  const lines = content.split('\n');
  const rules: RowProps[] = [];

  lines.forEach(line => {
    line = line.trim();  // This removes trailing and leading whitespaces

    let match = line.match(/^(Allow|Disallow):\s*(\S*)$/i);
    if (match) {
      const rule: RowProps = {
        lbl: match[1],
        val: match[2],
      };
      
      rules.push(rule);
    } else {
      match = line.match(/^(User-agent):\s*(\S*)$/i);
      if (match) {
        const rule: RowProps = {
          lbl: match[1],
          val: match[2],
        };
        
        rules.push(rule);
      }
    }
  });

  return { robots: rules };
}

export const applyWhoIsResults = (response: any) => {
  if (response.status !== '0') {
    return {
      error: response.status_desc,
    }
  }
  const whoIsResults: Whois = {
    created: response.date_created,
    expires: response.date_expires,
    updated: response.date_updated,
    nameservers: response.nameservers,
  };
  return whoIsResults;
}

